import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { OperationentityProductMappingFilter, OperationentityProductMappingAddEdit } from './Pages';

export const OperationentityProductMappingRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={OperationentityProductMappingFilter} />
        <Route exact path = {`${match.path}/AddEdit`} component={OperationentityProductMappingAddEdit} />
    </Fragment>
)